const Title = ({ title }: { title: string }) => {
  return <h2 className="mb-4" style={{ color: '#04105a' }}>{title}</h2>;
};

export default Title;